import { useEventsUser } from 'hooks/user/useEvents'

import { EventCarousel } from './eventCarousel'
import { LandingEvents } from './events'
import { Container } from './landing.styles'
import { LandingShows } from './shows'

export const Landing = () => {
    const { data: eventsData, isLoading, error } = useEventsUser()

    return (
        <Container>
            <EventCarousel data={eventsData} isLoading={isLoading} error={error} />
            <LandingShows />
            <LandingEvents data={eventsData} isLoading={isLoading} error={error} />
        </Container>
    )
}
